import * as types from './mutation-types';
import Vue from 'vue';

export default {
	// 改变登录状态
	[types.CHANGE_LOGINSTATE](state, payload) {
		state.isLogin = payload;
	},

	// 存储后置登录使用的手机号
	[types.SET_HASAUTHEDMOBILE](state, payload) {
		state.hasAuthedMobile = payload;
	},

	// 简历份数
	[types.SET_RESUME_COUNT](state, payload) {
		state.resumeCount = payload;
	},

	// 区域数据
	[types.SET_AREA_DATA](state, payload) {
		let secondarea = payload.secondarea,
			thridarea = payload.thridarea;
		// 一级城市全部的子元素
		let item = { parentId: secondarea[0].id, list: [secondarea[0]] };
		thridarea.unshift(item);

		state.areaInfo = [secondarea, thridarea];
	},

	// 改变已认证状态
	[types.CHANGE_HASAUTHED](state, payload) {
		state.hasAuthed = payload.auth; // 是否已认证
		if (payload.authMobile) {
			state.authMobile = payload.authMobile; // 存储返回的手机号
		}

		// 如果为已认证状态，则手机号/验证码置为true
		if (payload.auth) {
			state.basicInfo.mobile = true; // 修改填写状态
			state.basicInfo.keyCode = true; // 修改填写状态

			let basicInfo = state.basicInfo;
			for (let prop in basicInfo) {
				if (basicInfo.hasOwnProperty(prop)) {
					if (basicInfo[prop]) {
						state.basicInfoOk = true;
					} else {
						state.basicInfoOk = false;
						break;
					}
				}
			}
		}
	},

	// 提交隐私数据
	[types.SET_PRIVACY](state, payload) {
		Vue.set(state.privacyData, payload.key, payload.value); // 修改填写的值，为了能够监测到修改，所以使用set
	},

	// 屏蔽行业框展示状态
	[types.SET_BLOCK_INDUSTRY](state, payload) {
		state.showIndustry = payload;
	},

	// 更改图片上传状态
	[types.CHANGE_UPLOAD_STATE](state, payload) {
		state.uploadState = payload.state;
		Vue.set(state.submitData, 'pic', payload.picUrl); // 修改填写的值，为了第二页能够监测到修改，所以使用set
	},

	// 更改发布状态
	[types.CHANGE_SUBMITSTATE](state, payload) {
		state.submitState = payload.submitState;
		state.resumeId = payload.resumeId;
		state.submitErrorInfo = payload.submitErrorInfo;
		state.responseObj = payload.responseObj; // 滑块验证码参数
		state.showISDCaptcha = payload.responseObj ? true : false; // 是否展示滑块验证码
	},
	// 更改缓存中初始化职位、区域数据（或state字段数据）
	[types.CHANGE_OPTION](state, payload) {
		state[payload.key] = payload.value;
	},

	// 提交基础信息数据(非必填字段)
	[types.CHANGE_BASICINFO](state, payload) {
		Vue.set(state.submitData, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set
	},

	// 改变基本信息填写状态/填写内容以及检查是否填写完整
	[types.CHECK_BASICINFO](state, payload) {
		state.basicInfo[payload.key] = payload.state; // 修改填写状态
		Vue.set(state.submitData, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set

		let basicInfo = state.basicInfo;
		for (let prop in basicInfo) {
			if (basicInfo.hasOwnProperty(prop)) {
				if (basicInfo[prop]) {
					state.basicInfoOk = true;
				} else {
					state.basicInfoOk = false;
					break;
				}
			}
		}
	},
	// 改变求职信息填写状态/填写内容以及检查是否填写完整
	[types.CHECK_EXPECTIONINFO](state, payload) {
		state.expectionInfo[payload.key] = payload.state; // 修改填写状态
		Vue.set(state.submitData, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set

		let expectionInfo = state.expectionInfo;
		for (let prop in expectionInfo) {
			if (expectionInfo.hasOwnProperty(prop)) {
				if (expectionInfo[prop]) {
					state.expectionInfoOk = true;
				} else {
					state.expectionInfoOk = false;
					break;
				}
			}
		}
	},

	// 提交教育经历信息数据(非必填字段)
	[types.CHANGE_EDUTION](state, payload) {
		Vue.set(state.educationInfo, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set
	},

	// 更改教育经历操作状态
	[types.CHECK_EDUINFO](state, payload) {
		state.educationCheck[payload.key] = payload.state;
		Vue.set(state.educationInfo, payload.key, payload.value); // 修改填写的值，为了第二页能够监测到修改，所以使用set

		let educationCheck = state.educationCheck;
		for (let prop in educationCheck) {
			if (educationCheck.hasOwnProperty(prop)) {
				if (educationCheck[prop]) {
					state.educationOk = true;
				} else {
					state.educationOk = false;
					break;
				}
			}
		}
	},
	[types.SET_ALLCONFIGOTHERDATA](state, payload){
		state.allConfigOtherData = payload;
	}
};



// WEBPACK FOOTER //
// ./src/module/basic/store/mutations.js